import { useCallback, useEffect, useState } from "react";
import { useSearch } from "wouter/use-browser-location";

/** A search link must also work when navigating to the page already open. */
export function useSearchQueryParam() {
  const search = useSearch();
  const query = new URLSearchParams(search).get("q");
  const [value, setValue] = useState(() => query ?? "");
  useEffect(() => { setValue(query ?? ""); }, [query]);
  return [value, setValue, query] as const;
}

/** Search links broaden a saved filter without changing the user's preferences. */
export function useSearchFilterOverride<T>(
  query: string | null,
  saved: [T, (next: T) => void],
  searchDefault: T,
) {
  const [savedValue, saveValue] = saved;
  const [override, setOverride] = useState<T | undefined>(() => query !== null ? searchDefault : undefined);
  useEffect(() => {
    setOverride(query !== null ? searchDefault : undefined);
  }, [query, searchDefault]);
  const setValue = useCallback((next: T) => {
    setOverride(next);
    saveValue(next);
  }, [saveValue]);
  return [override ?? savedValue, setValue] as const;
}